<template>
  <div :class="errorClasses">
    <slot />
    <p v-for="(error, i) in errors" :key="i" class="error-text">{{error.message}}</p>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import ValidationError from "~/models/validationError";
import objectModelEntryPropertiesMixin from "~/mixins/objectModelEntries/objectModelEntryPropertiesMixin";
import selectedMixin from "../mixins/selectedMixin";

export default Vue.extend({
  mixins: [objectModelEntryPropertiesMixin, selectedMixin],
  computed: {
    hasErrors(): boolean {
      return this.errors.length > 0;
    },
    errors(): ValidationError[] | null {
      return this.selectedObjectModelEntry.validationErrors.filter(it => it.field === this.propertyClientId);
    },
    errorClasses(): object {
      return { field_with_errors: this.errors.length > 0 };
    }
  }
});
</script>